import { render, staticRenderFns } from "./BusinessPlanReportCard.vue?vue&type=template&id=16168563"
import script from "./BusinessPlanReportCard.vue?vue&type=script&lang=ts"
export * from "./BusinessPlanReportCard.vue?vue&type=script&lang=ts"
import style0 from "./BusinessPlanReportCard.vue?vue&type=style&index=0&id=16168563&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports